import apiClient from './client';

export const BulkClaimAxiosInstance = apiClient;